import React from 'react';
import { Create } from 'react-admin';
import HelpForm from './form';

const HelpCreate = (props) => {
  const { resource } = props;

  return (
    <Create title={`resources.${resource}.titles.create`} {...props}>
      <HelpForm />
    </Create>
  );
};

export default HelpCreate;
